import styled, { css } from 'styled-components';

import { Colors } from './types';

export const Container = styled.button<{
  $selected: boolean;
  $isMobileOutlined: boolean;
  $isFrozen: boolean;
  $minimalStartSpacing: boolean;
  $minimalEndSpacing: boolean;
}>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;

  margin: 0;
  padding: 0;

  max-width: 100%;

  background: transparent;
  border: none;
  transition: color 200ms;

  color: ${({ theme }) => theme.palette.grey[600]};

  ${({ onClick, theme }) =>
    !!onClick &&
    css`
      cursor: pointer;

      @media (any-hover: hover) {
        &:hover {
          color: ${theme.palette.text.primary};
        }
      }
    `}

  ${({ $selected, theme }) =>
    $selected &&
    css`
      color: ${theme.palette.text.primary};
    `};

  ${({ theme, $isMobileOutlined }) =>
    theme.isMobile &&
    $isMobileOutlined &&
    css`
      padding: ${`${theme.spacing(1.5)} ${theme.spacing(3)}`};
      height: 3.2rem;

      border: 1px solid ${theme.palette.grey['100']};
      border-radius: ${theme.spacing(2)};
    `};

  ${({ $isFrozen }) =>
    $isFrozen &&
    css`
      cursor: none;
      pointer-events: none;
    `};
`;

export const IconContainer = styled.span<{ $color: Colors }>`
  line-height: 62.5%;
  font-size: 1.2rem;

  color: ${({ $color, theme }) => {
    switch ($color) {
      case Colors.Inherit:
        return 'inherit';
      case Colors.Primary:
        return theme.palette.primary.main;
      case Colors.Secondary:
        return theme.palette.secondary.main;
      case Colors.Info:
        return theme.palette.info.main;
      case Colors.Success:
        return theme.palette.success.main;
      case Colors.Warning:
        return theme.palette.warning.main;
      case Colors.Error:
        return theme.palette.error.main;
    }
  }};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      font-size: 1.6rem;
    `};
`;

export const Title = styled.span<{ $color: Colors }>`
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${({ $color, theme }) => {
    switch ($color) {
      case Colors.Inherit:
        return 'inherit';
      case Colors.Primary:
        return theme.palette.primary.main;
      case Colors.Secondary:
        return theme.palette.secondary.main;
      case Colors.TextPrimary:
        return theme.palette.text.primary;
      case Colors.Info:
        return theme.palette.info.main;
      case Colors.Success:
        return theme.palette.success.main;
      case Colors.Warning:
        return theme.palette.warning.main;
      case Colors.Error:
        return theme.palette.error.main;
    }
  }};

  ${({ theme, $color }) =>
    $color === Colors.Inherit &&
    css`
      &:hover {
        color: ${theme.palette.text.primary};
      }
    `};
`;
